import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_audit_trail,
    getReportLabel: () => t`Audit Trails`,
    getColumns: () => [],
};
